var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendarDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 34,
    height: 34,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_28",
    "data-name": "Mask Group 28",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_calendar-alt_",
    "data-name": "FontAwsome (calendar-alt)",
    d: "M5.2,10.125H3.8A.423.423,0,0,1,3.375,9.7V8.3A.423.423,0,0,1,3.8,7.875H5.2a.423.423,0,0,1,.422.422V9.7A.423.423,0,0,1,5.2,10.125ZM9,9.7V8.3a.423.423,0,0,0-.422-.422H7.172A.423.423,0,0,0,6.75,8.3V9.7a.423.423,0,0,0,.422.422H8.578A.423.423,0,0,0,9,9.7Zm3.375,0V8.3a.423.423,0,0,0-.422-.422H10.547a.423.423,0,0,0-.422.422V9.7a.423.423,0,0,0,.422.422h1.406A.423.423,0,0,0,12.375,9.7ZM9,13.078V11.672a.423.423,0,0,0-.422-.422H7.172a.423.423,0,0,0-.422.422v1.406a.423.423,0,0,0,.422.422H8.578A.423.423,0,0,0,9,13.078Zm-3.375,0V11.672A.423.423,0,0,0,5.2,11.25H3.8a.423.423,0,0,0-.422.422v1.406A.423.423,0,0,0,3.8,13.5H5.2A.423.423,0,0,0,5.625,13.078Zm6.75,0V11.672a.423.423,0,0,0-.422-.422H10.547a.423.423,0,0,0-.422.422v1.406a.423.423,0,0,0,.422.422h1.406A.423.423,0,0,0,12.375,13.078ZM15.75,3.938V16.313A1.688,1.688,0,0,1,14.063,18H1.688A1.688,1.688,0,0,1,0,16.313V3.938A1.688,1.688,0,0,1,1.688,2.25H3.375V.422A.423.423,0,0,1,3.8,0H5.2a.423.423,0,0,1,.422.422V2.25h4.5V.422A.423.423,0,0,1,10.547,0h1.406a.423.423,0,0,1,.422.422V2.25h1.688A1.688,1.688,0,0,1,15.75,3.938ZM14.063,16.1V5.625H1.688V16.1a.212.212,0,0,0,.211.211H13.852A.212.212,0,0,0,14.063,16.1Z",
    transform: "translate(9.625 8)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarDisabled);
export default __webpack_public_path__ + "static/media/icon_calendar_disabled.0df07de9bf8c7f4149765d7f7f37f2d9.svg";
export { ForwardRef as ReactComponent };